import { memo, PropsWithChildren } from 'react'
import { makeStyles, createStyles } from '@mui/styles'

import Header from '../header/Header'
import Footer from '../footer/Footer'
import SmavaFooter from '../footer/smava'

import { isSmava } from '../../utils/getTenantInfo.utils'

const useStyles = makeStyles(() =>
  createStyles({
    app: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
    },
    content: {
      flexGrow: 1,
    },
  }),
)

const Page = ({
  hasHeader = true,
  extendedFooter = true,
  children,
}: PropsWithChildren<Record<string, unknown>>) => {
  const { app, content } = useStyles()

  return (
    <div className={app}>
      {hasHeader ? <Header /> : ''}
      <div className={content}>{children}</div>
      {isSmava ? (
        <SmavaFooter extended={!!extendedFooter} />
      ) : (
        <Footer extended={!!extendedFooter} />
      )}
    </div>
  )
}

export default memo(Page)
